// source: proto/reportpb/clientsummary.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
goog.exportSymbol('proto.reportpb.ClientSummaryAccountSetup', null, global);
goog.exportSymbol('proto.reportpb.ClientSummaryBalance', null, global);
goog.exportSymbol('proto.reportpb.ClientSummaryMarginRequirement', null, global);
goog.exportSymbol('proto.reportpb.ClientSummaryNonTrade', null, global);
goog.exportSymbol('proto.reportpb.ClientSummaryPosition', null, global);
goog.exportSymbol('proto.reportpb.ClientSummarySegregation', null, global);
goog.exportSymbol('proto.reportpb.ClientSummaryTrade', null, global);
goog.exportSymbol('proto.reportpb.ListClientSummaryRequest', null, global);
goog.exportSymbol('proto.reportpb.ListClientSummaryResponse', null, global);
goog.exportSymbol('proto.reportpb.ListMarginRequirementDetailsRequest', null, global);
goog.exportSymbol('proto.reportpb.ListMarginRequirementDetailsResponse', null, global);
goog.exportSymbol('proto.reportpb.ListSegregationDetailsRequest', null, global);
goog.exportSymbol('proto.reportpb.ListSegregationDetailsResponse', null, global);
goog.exportSymbol('proto.reportpb.MarginRequirementDetail', null, global);
goog.exportSymbol('proto.reportpb.SegregationDetail', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ClientSummaryBalance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ClientSummaryBalance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ClientSummaryBalance.displayName = 'proto.reportpb.ClientSummaryBalance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ClientSummaryPosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ClientSummaryPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ClientSummaryPosition.displayName = 'proto.reportpb.ClientSummaryPosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ClientSummaryMarginRequirement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ClientSummaryMarginRequirement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ClientSummaryMarginRequirement.displayName = 'proto.reportpb.ClientSummaryMarginRequirement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ClientSummarySegregation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ClientSummarySegregation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ClientSummarySegregation.displayName = 'proto.reportpb.ClientSummarySegregation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ClientSummaryNonTrade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ClientSummaryNonTrade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ClientSummaryNonTrade.displayName = 'proto.reportpb.ClientSummaryNonTrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ClientSummaryTrade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ClientSummaryTrade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ClientSummaryTrade.displayName = 'proto.reportpb.ClientSummaryTrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ClientSummaryAccountSetup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ClientSummaryAccountSetup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ClientSummaryAccountSetup.displayName = 'proto.reportpb.ClientSummaryAccountSetup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListClientSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListClientSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListClientSummaryRequest.displayName = 'proto.reportpb.ListClientSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListClientSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListClientSummaryResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListClientSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListClientSummaryResponse.displayName = 'proto.reportpb.ListClientSummaryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.MarginRequirementDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.MarginRequirementDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.MarginRequirementDetail.displayName = 'proto.reportpb.MarginRequirementDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListMarginRequirementDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListMarginRequirementDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListMarginRequirementDetailsRequest.displayName = 'proto.reportpb.ListMarginRequirementDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListMarginRequirementDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListMarginRequirementDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListMarginRequirementDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListMarginRequirementDetailsResponse.displayName = 'proto.reportpb.ListMarginRequirementDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.SegregationDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.SegregationDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.SegregationDetail.displayName = 'proto.reportpb.SegregationDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListSegregationDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListSegregationDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListSegregationDetailsRequest.displayName = 'proto.reportpb.ListSegregationDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListSegregationDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListSegregationDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListSegregationDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListSegregationDetailsResponse.displayName = 'proto.reportpb.ListSegregationDetailsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ClientSummaryBalance.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ClientSummaryBalance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ClientSummaryBalance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryBalance.toObject = function(includeInstance, msg) {
  var f, obj = {
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 8, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 9, ""),
    broker: jspb.Message.getFieldWithDefault(msg, 10, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 11, ""),
    type: jspb.Message.getFieldWithDefault(msg, 12, ""),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 13, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 14, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 15, ""),
    equity: jspb.Message.getFieldWithDefault(msg, 16, ""),
    adjustedBalance: jspb.Message.getFieldWithDefault(msg, 17, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 18, ""),
    lastActivityDate: (f = msg.getLastActivityDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    moneyMarket: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ClientSummaryBalance}
 */
proto.reportpb.ClientSummaryBalance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ClientSummaryBalance;
  return proto.reportpb.ClientSummaryBalance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ClientSummaryBalance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ClientSummaryBalance}
 */
proto.reportpb.ClientSummaryBalance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setEquity(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjustedBalance(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    case 19:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setLastActivityDate(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMoneyMarket(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ClientSummaryBalance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ClientSummaryBalance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ClientSummaryBalance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryBalance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getEquity();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getLastActivityDate();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getMoneyMarket();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional google.type.Date trade_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryBalance.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
*/
proto.reportpb.ClientSummaryBalance.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryBalance.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 account_id = 2;
 * @return {number}
 */
proto.reportpb.ClientSummaryBalance.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string correspondent = 3;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string branch = 4;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_no = 5;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string sub_account_no = 6;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string account_name = 7;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string master_account_no = 8;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string rep = 9;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string broker = 10;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string margin_type = 11;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string type = 12;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string cash_balance = 13;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string short_market_value = 14;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string long_market_value = 15;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string equity = 16;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string adjusted_balance = 17;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string msg = 18;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional google.type.Date last_activity_date = 19;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryBalance.prototype.getLastActivityDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 19));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
*/
proto.reportpb.ClientSummaryBalance.prototype.setLastActivityDate = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.clearLastActivityDate = function() {
  return this.setLastActivityDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryBalance.prototype.hasLastActivityDate = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string money_market = 20;
 * @return {string}
 */
proto.reportpb.ClientSummaryBalance.prototype.getMoneyMarket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryBalance} returns this
 */
proto.reportpb.ClientSummaryBalance.prototype.setMoneyMarket = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ClientSummaryPosition.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ClientSummaryPosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ClientSummaryPosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryPosition.toObject = function(includeInstance, msg) {
  var f, obj = {
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    assetType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 6, ""),
    closingPrice: jspb.Message.getFieldWithDefault(msg, 7, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    costBasis: jspb.Message.getFieldWithDefault(msg, 9, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ClientSummaryPosition}
 */
proto.reportpb.ClientSummaryPosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ClientSummaryPosition;
  return proto.reportpb.ClientSummaryPosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ClientSummaryPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ClientSummaryPosition}
 */
proto.reportpb.ClientSummaryPosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosingPrice(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCostBasis(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ClientSummaryPosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ClientSummaryPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ClientSummaryPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryPosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCostBasis();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional google.type.Date trade_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryPosition.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
*/
proto.reportpb.ClientSummaryPosition.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryPosition.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string cusip = 3;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol_description = 4;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string asset_type = 5;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string qty = 6;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string closing_price = 7;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getClosingPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setClosingPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string market_value = 8;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string cost_basis = 9;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getCostBasis = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setCostBasis = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string msg = 10;
 * @return {string}
 */
proto.reportpb.ClientSummaryPosition.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryPosition} returns this
 */
proto.reportpb.ClientSummaryPosition.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ClientSummaryMarginRequirement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ClientSummaryMarginRequirement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryMarginRequirement.toObject = function(includeInstance, msg) {
  var f, obj = {
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 4, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 5, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    totalEquity: jspb.Message.getFieldWithDefault(msg, 7, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    exchangeReq: jspb.Message.getFieldWithDefault(msg, 9, ""),
    exchangeCall: jspb.Message.getFieldWithDefault(msg, 10, ""),
    fedReq: jspb.Message.getFieldWithDefault(msg, 11, ""),
    fedCall: jspb.Message.getFieldWithDefault(msg, 12, ""),
    houseReq: jspb.Message.getFieldWithDefault(msg, 13, ""),
    houseCall: jspb.Message.getFieldWithDefault(msg, 14, ""),
    minBalanceCall: jspb.Message.getFieldWithDefault(msg, 15, ""),
    sma: jspb.Message.getFieldWithDefault(msg, 16, ""),
    multiplier: jspb.Message.getFieldWithDefault(msg, 17, ""),
    buyingPower: jspb.Message.getFieldWithDefault(msg, 18, ""),
    buyingPowerUsed: jspb.Message.getFieldWithDefault(msg, 19, ""),
    buyingPowerCall: jspb.Message.getFieldWithDefault(msg, 20, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ClientSummaryMarginRequirement}
 */
proto.reportpb.ClientSummaryMarginRequirement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ClientSummaryMarginRequirement;
  return proto.reportpb.ClientSummaryMarginRequirement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ClientSummaryMarginRequirement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ClientSummaryMarginRequirement}
 */
proto.reportpb.ClientSummaryMarginRequirement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalEquity(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeReq(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeCall(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedReq(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedCall(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseReq(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseCall(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinBalanceCall(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSma(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setMultiplier(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyingPower(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyingPowerUsed(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyingPowerCall(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ClientSummaryMarginRequirement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ClientSummaryMarginRequirement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryMarginRequirement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTotalEquity();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getExchangeCall();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFedReq();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFedCall();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getHouseReq();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getHouseCall();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMinBalanceCall();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSma();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getMultiplier();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getBuyingPower();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getBuyingPowerUsed();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getBuyingPowerCall();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string master_account_no = 1;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string margin_type = 2;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.type.Date trade_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
*/
proto.reportpb.ClientSummaryMarginRequirement.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string cash_balance = 4;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string long_market_value = 5;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string short_market_value = 6;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string total_equity = 7;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getTotalEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setTotalEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string market_value = 8;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string exchange_req = 9;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string exchange_call = 10;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getExchangeCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setExchangeCall = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string fed_req = 11;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string fed_call = 12;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getFedCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setFedCall = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string house_req = 13;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string house_call = 14;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getHouseCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setHouseCall = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string min_balance_call = 15;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getMinBalanceCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setMinBalanceCall = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string sma = 16;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getSma = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setSma = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string multiplier = 17;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getMultiplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string buying_power = 18;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getBuyingPower = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setBuyingPower = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string buying_power_used = 19;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getBuyingPowerUsed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setBuyingPowerUsed = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string buying_power_call = 20;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getBuyingPowerCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setBuyingPowerCall = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string msg = 21;
 * @return {string}
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryMarginRequirement} returns this
 */
proto.reportpb.ClientSummaryMarginRequirement.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ClientSummarySegregation.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ClientSummarySegregation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ClientSummarySegregation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummarySegregation.toObject = function(includeInstance, msg) {
  var f, obj = {
    settleDate: (f = msg.getSettleDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 3, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    adjustedBalance: jspb.Message.getFieldWithDefault(msg, 5, ""),
    loanRate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    loanValue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    lockup: jspb.Message.getFieldWithDefault(msg, 9, ""),
    segAmt: jspb.Message.getFieldWithDefault(msg, 10, ""),
    excessMarginAmt: jspb.Message.getFieldWithDefault(msg, 11, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ClientSummarySegregation}
 */
proto.reportpb.ClientSummarySegregation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ClientSummarySegregation;
  return proto.reportpb.ClientSummarySegregation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ClientSummarySegregation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ClientSummarySegregation}
 */
proto.reportpb.ClientSummarySegregation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSettleDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjustedBalance(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoanRate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoanValue(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockup(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegAmt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setExcessMarginAmt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ClientSummarySegregation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ClientSummarySegregation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ClientSummarySegregation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummarySegregation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettleDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLoanRate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLoanValue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLockup();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSegAmt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getExcessMarginAmt();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional google.type.Date settle_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummarySegregation.prototype.getSettleDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
*/
proto.reportpb.ClientSummarySegregation.prototype.setSettleDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.clearSettleDate = function() {
  return this.setSettleDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummarySegregation.prototype.hasSettleDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string master_account_no = 2;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string cash_balance = 3;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string short_market_value = 4;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string adjusted_balance = 5;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string loan_rate = 6;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getLoanRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setLoanRate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string loan_value = 7;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getLoanValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setLoanValue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string long_market_value = 8;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string lockup = 9;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getLockup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setLockup = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string seg_amt = 10;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getSegAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setSegAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string excess_margin_amt = 11;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getExcessMarginAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setExcessMarginAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string msg = 12;
 * @return {string}
 */
proto.reportpb.ClientSummarySegregation.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummarySegregation} returns this
 */
proto.reportpb.ClientSummarySegregation.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ClientSummaryNonTrade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ClientSummaryNonTrade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryNonTrade.toObject = function(includeInstance, msg) {
  var f, obj = {
    entryType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    settleDate: (f = msg.getSettleDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 6, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 7, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 8, ""),
    price: jspb.Message.getFieldWithDefault(msg, 9, ""),
    grossAmt: jspb.Message.getFieldWithDefault(msg, 10, ""),
    fees: jspb.Message.getFieldWithDefault(msg, 11, ""),
    netAmt: jspb.Message.getFieldWithDefault(msg, 12, ""),
    description: jspb.Message.getFieldWithDefault(msg, 13, ""),
    status: jspb.Message.getFieldWithDefault(msg, 14, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ClientSummaryNonTrade}
 */
proto.reportpb.ClientSummaryNonTrade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ClientSummaryNonTrade;
  return proto.reportpb.ClientSummaryNonTrade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ClientSummaryNonTrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ClientSummaryNonTrade}
 */
proto.reportpb.ClientSummaryNonTrade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntryType(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSettleDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrossAmt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFees(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetAmt(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ClientSummaryNonTrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ClientSummaryNonTrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryNonTrade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntryType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSettleDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFees();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getNetAmt();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string entry_type = 1;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getEntryType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setEntryType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Date system_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
*/
proto.reportpb.ClientSummaryNonTrade.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.type.Date trade_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
*/
proto.reportpb.ClientSummaryNonTrade.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Date settle_date = 4;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getSettleDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
*/
proto.reportpb.ClientSummaryNonTrade.prototype.setSettleDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.clearSettleDate = function() {
  return this.setSettleDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.hasSettleDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string cusip = 6;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string symbol_description = 7;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string qty = 8;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string price = 9;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string gross_amt = 10;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string fees = 11;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getFees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setFees = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string net_amt = 12;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string description = 13;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string status = 14;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string msg = 15;
 * @return {string}
 */
proto.reportpb.ClientSummaryNonTrade.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryNonTrade} returns this
 */
proto.reportpb.ClientSummaryNonTrade.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ClientSummaryTrade.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ClientSummaryTrade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ClientSummaryTrade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryTrade.toObject = function(includeInstance, msg) {
  var f, obj = {
    entryType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    systemDate: (f = msg.getSystemDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    tradeDate: (f = msg.getTradeDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    settleDate: (f = msg.getSettleDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    side: jspb.Message.getFieldWithDefault(msg, 6, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 7, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 8, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 9, ""),
    price: jspb.Message.getFieldWithDefault(msg, 10, ""),
    grossAmt: jspb.Message.getFieldWithDefault(msg, 11, ""),
    regFee: jspb.Message.getFieldWithDefault(msg, 12, ""),
    tafFee: jspb.Message.getFieldWithDefault(msg, 13, ""),
    fees: jspb.Message.getFieldWithDefault(msg, 14, ""),
    netAmt: jspb.Message.getFieldWithDefault(msg, 15, ""),
    description: jspb.Message.getFieldWithDefault(msg, 16, ""),
    status: jspb.Message.getFieldWithDefault(msg, 17, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ClientSummaryTrade}
 */
proto.reportpb.ClientSummaryTrade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ClientSummaryTrade;
  return proto.reportpb.ClientSummaryTrade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ClientSummaryTrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ClientSummaryTrade}
 */
proto.reportpb.ClientSummaryTrade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntryType(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSystemDate(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setTradeDate(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setSettleDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrossAmt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegFee(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTafFee(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setFees(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetAmt(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ClientSummaryTrade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ClientSummaryTrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ClientSummaryTrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryTrade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntryType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTradeDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSettleDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getGrossAmt();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRegFee();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTafFee();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getFees();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getNetAmt();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string entry_type = 1;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getEntryType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setEntryType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Date system_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryTrade.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
*/
proto.reportpb.ClientSummaryTrade.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryTrade.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.type.Date trade_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryTrade.prototype.getTradeDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
*/
proto.reportpb.ClientSummaryTrade.prototype.setTradeDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.clearTradeDate = function() {
  return this.setTradeDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryTrade.prototype.hasTradeDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.type.Date settle_date = 4;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryTrade.prototype.getSettleDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
*/
proto.reportpb.ClientSummaryTrade.prototype.setSettleDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.clearSettleDate = function() {
  return this.setSettleDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryTrade.prototype.hasSettleDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string side = 6;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string cusip = 7;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string symbol_description = 8;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string qty = 9;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string price = 10;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string gross_amt = 11;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getGrossAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setGrossAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string reg_fee = 12;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getRegFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setRegFee = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string taf_fee = 13;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getTafFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setTafFee = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string fees = 14;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getFees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setFees = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string net_amt = 15;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string description = 16;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string status = 17;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string msg = 18;
 * @return {string}
 */
proto.reportpb.ClientSummaryTrade.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryTrade} returns this
 */
proto.reportpb.ClientSummaryTrade.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ClientSummaryAccountSetup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ClientSummaryAccountSetup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryAccountSetup.toObject = function(includeInstance, msg) {
  var f, obj = {
    marginType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    largeTraderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dayTrader: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    multiplier: jspb.Message.getFieldWithDefault(msg, 4, ""),
    allowLiquidInvestment: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    accreditedInvestor: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    marginDisclosure: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    marginAgreement: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    fpslParticipant: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    fdidFlag: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    fdid: jspb.Message.getFieldWithDefault(msg, 11, ""),
    fdidEndReason: jspb.Message.getFieldWithDefault(msg, 12, ""),
    stocks: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    etf: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    option: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    investmentObjectiveCode: jspb.Message.getFieldWithDefault(msg, 16, ""),
    investmentObjectiveDate: (f = msg.getInvestmentObjectiveDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    annualIncome: jspb.Message.getFieldWithDefault(msg, 18, ""),
    liquidNetWorth: jspb.Message.getFieldWithDefault(msg, 19, ""),
    sourceOfFunds: jspb.Message.getFieldWithDefault(msg, 20, ""),
    serviceBureau: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ClientSummaryAccountSetup}
 */
proto.reportpb.ClientSummaryAccountSetup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ClientSummaryAccountSetup;
  return proto.reportpb.ClientSummaryAccountSetup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ClientSummaryAccountSetup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ClientSummaryAccountSetup}
 */
proto.reportpb.ClientSummaryAccountSetup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLargeTraderId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDayTrader(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMultiplier(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowLiquidInvestment(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccreditedInvestor(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginDisclosure(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginAgreement(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFpslParticipant(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFdidFlag(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFdid(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFdidEndReason(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStocks(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEtf(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOption(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvestmentObjectiveCode(value);
      break;
    case 17:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setInvestmentObjectiveDate(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnualIncome(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiquidNetWorth(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceOfFunds(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceBureau(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ClientSummaryAccountSetup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ClientSummaryAccountSetup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ClientSummaryAccountSetup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLargeTraderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDayTrader();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMultiplier();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAllowLiquidInvestment();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAccreditedInvestor();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMarginDisclosure();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMarginAgreement();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getFpslParticipant();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getFdidFlag();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getFdid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFdidEndReason();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getStocks();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getEtf();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getOption();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getInvestmentObjectiveCode();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getInvestmentObjectiveDate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAnnualIncome();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getLiquidNetWorth();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSourceOfFunds();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getServiceBureau();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string margin_type = 1;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string large_trader_id = 2;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getLargeTraderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setLargeTraderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool day_trader = 3;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getDayTrader = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setDayTrader = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string multiplier = 4;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getMultiplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool allow_liquid_investment = 5;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getAllowLiquidInvestment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setAllowLiquidInvestment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool accredited_investor = 6;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getAccreditedInvestor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setAccreditedInvestor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool margin_disclosure = 7;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getMarginDisclosure = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setMarginDisclosure = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool margin_agreement = 8;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getMarginAgreement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setMarginAgreement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool fpsl_participant = 9;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getFpslParticipant = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setFpslParticipant = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool fdid_flag = 10;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getFdidFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setFdidFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string fdid = 11;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getFdid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setFdid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string fdid_end_reason = 12;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getFdidEndReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setFdidEndReason = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool stocks = 13;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getStocks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setStocks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool etf = 14;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getEtf = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setEtf = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool option = 15;
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getOption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setOption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string investment_objective_code = 16;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getInvestmentObjectiveCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setInvestmentObjectiveCode = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.type.Date investment_objective_date = 17;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getInvestmentObjectiveDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 17));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
*/
proto.reportpb.ClientSummaryAccountSetup.prototype.setInvestmentObjectiveDate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.clearInvestmentObjectiveDate = function() {
  return this.setInvestmentObjectiveDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.hasInvestmentObjectiveDate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string annual_income = 18;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getAnnualIncome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setAnnualIncome = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string liquid_net_worth = 19;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getLiquidNetWorth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setLiquidNetWorth = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string source_of_funds = 20;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getSourceOfFunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setSourceOfFunds = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string service_bureau = 21;
 * @return {string}
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.getServiceBureau = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ClientSummaryAccountSetup} returns this
 */
proto.reportpb.ClientSummaryAccountSetup.prototype.setServiceBureau = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListClientSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListClientSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListClientSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListClientSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    accountNo: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListClientSummaryRequest}
 */
proto.reportpb.ListClientSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListClientSummaryRequest;
  return proto.reportpb.ListClientSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListClientSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListClientSummaryRequest}
 */
proto.reportpb.ListClientSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListClientSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListClientSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListClientSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListClientSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional google.type.Date date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListClientSummaryRequest.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListClientSummaryRequest} returns this
*/
proto.reportpb.ListClientSummaryRequest.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListClientSummaryRequest} returns this
 */
proto.reportpb.ListClientSummaryRequest.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListClientSummaryRequest.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.reportpb.ListClientSummaryRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListClientSummaryRequest} returns this
 */
proto.reportpb.ListClientSummaryRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListClientSummaryResponse.repeatedFields_ = [2,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListClientSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListClientSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListClientSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListClientSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    balance: (f = msg.getBalance()) && proto.reportpb.ClientSummaryBalance.toObject(includeInstance, f),
    positionsList: jspb.Message.toObjectList(msg.getPositionsList(),
    proto.reportpb.ClientSummaryPosition.toObject, includeInstance),
    marginRequirement: (f = msg.getMarginRequirement()) && proto.reportpb.ClientSummaryMarginRequirement.toObject(includeInstance, f),
    segregation: (f = msg.getSegregation()) && proto.reportpb.ClientSummarySegregation.toObject(includeInstance, f),
    nonTradesList: jspb.Message.toObjectList(msg.getNonTradesList(),
    proto.reportpb.ClientSummaryNonTrade.toObject, includeInstance),
    tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.reportpb.ClientSummaryTrade.toObject, includeInstance),
    accountSetup: (f = msg.getAccountSetup()) && proto.reportpb.ClientSummaryAccountSetup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListClientSummaryResponse}
 */
proto.reportpb.ListClientSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListClientSummaryResponse;
  return proto.reportpb.ListClientSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListClientSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListClientSummaryResponse}
 */
proto.reportpb.ListClientSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.ClientSummaryBalance;
      reader.readMessage(value,proto.reportpb.ClientSummaryBalance.deserializeBinaryFromReader);
      msg.setBalance(value);
      break;
    case 2:
      var value = new proto.reportpb.ClientSummaryPosition;
      reader.readMessage(value,proto.reportpb.ClientSummaryPosition.deserializeBinaryFromReader);
      msg.addPositions(value);
      break;
    case 3:
      var value = new proto.reportpb.ClientSummaryMarginRequirement;
      reader.readMessage(value,proto.reportpb.ClientSummaryMarginRequirement.deserializeBinaryFromReader);
      msg.setMarginRequirement(value);
      break;
    case 4:
      var value = new proto.reportpb.ClientSummarySegregation;
      reader.readMessage(value,proto.reportpb.ClientSummarySegregation.deserializeBinaryFromReader);
      msg.setSegregation(value);
      break;
    case 5:
      var value = new proto.reportpb.ClientSummaryNonTrade;
      reader.readMessage(value,proto.reportpb.ClientSummaryNonTrade.deserializeBinaryFromReader);
      msg.addNonTrades(value);
      break;
    case 6:
      var value = new proto.reportpb.ClientSummaryTrade;
      reader.readMessage(value,proto.reportpb.ClientSummaryTrade.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    case 7:
      var value = new proto.reportpb.ClientSummaryAccountSetup;
      reader.readMessage(value,proto.reportpb.ClientSummaryAccountSetup.deserializeBinaryFromReader);
      msg.setAccountSetup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListClientSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListClientSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListClientSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListClientSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.reportpb.ClientSummaryBalance.serializeBinaryToWriter
    );
  }
  f = message.getPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.reportpb.ClientSummaryPosition.serializeBinaryToWriter
    );
  }
  f = message.getMarginRequirement();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.reportpb.ClientSummaryMarginRequirement.serializeBinaryToWriter
    );
  }
  f = message.getSegregation();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.reportpb.ClientSummarySegregation.serializeBinaryToWriter
    );
  }
  f = message.getNonTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.reportpb.ClientSummaryNonTrade.serializeBinaryToWriter
    );
  }
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.reportpb.ClientSummaryTrade.serializeBinaryToWriter
    );
  }
  f = message.getAccountSetup();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.reportpb.ClientSummaryAccountSetup.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClientSummaryBalance balance = 1;
 * @return {?proto.reportpb.ClientSummaryBalance}
 */
proto.reportpb.ListClientSummaryResponse.prototype.getBalance = function() {
  return /** @type{?proto.reportpb.ClientSummaryBalance} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ClientSummaryBalance, 1));
};


/**
 * @param {?proto.reportpb.ClientSummaryBalance|undefined} value
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
*/
proto.reportpb.ListClientSummaryResponse.prototype.setBalance = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
 */
proto.reportpb.ListClientSummaryResponse.prototype.clearBalance = function() {
  return this.setBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListClientSummaryResponse.prototype.hasBalance = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ClientSummaryPosition positions = 2;
 * @return {!Array<!proto.reportpb.ClientSummaryPosition>}
 */
proto.reportpb.ListClientSummaryResponse.prototype.getPositionsList = function() {
  return /** @type{!Array<!proto.reportpb.ClientSummaryPosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.ClientSummaryPosition, 2));
};


/**
 * @param {!Array<!proto.reportpb.ClientSummaryPosition>} value
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
*/
proto.reportpb.ListClientSummaryResponse.prototype.setPositionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.reportpb.ClientSummaryPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ClientSummaryPosition}
 */
proto.reportpb.ListClientSummaryResponse.prototype.addPositions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.reportpb.ClientSummaryPosition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
 */
proto.reportpb.ListClientSummaryResponse.prototype.clearPositionsList = function() {
  return this.setPositionsList([]);
};


/**
 * optional ClientSummaryMarginRequirement margin_requirement = 3;
 * @return {?proto.reportpb.ClientSummaryMarginRequirement}
 */
proto.reportpb.ListClientSummaryResponse.prototype.getMarginRequirement = function() {
  return /** @type{?proto.reportpb.ClientSummaryMarginRequirement} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ClientSummaryMarginRequirement, 3));
};


/**
 * @param {?proto.reportpb.ClientSummaryMarginRequirement|undefined} value
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
*/
proto.reportpb.ListClientSummaryResponse.prototype.setMarginRequirement = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
 */
proto.reportpb.ListClientSummaryResponse.prototype.clearMarginRequirement = function() {
  return this.setMarginRequirement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListClientSummaryResponse.prototype.hasMarginRequirement = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ClientSummarySegregation segregation = 4;
 * @return {?proto.reportpb.ClientSummarySegregation}
 */
proto.reportpb.ListClientSummaryResponse.prototype.getSegregation = function() {
  return /** @type{?proto.reportpb.ClientSummarySegregation} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ClientSummarySegregation, 4));
};


/**
 * @param {?proto.reportpb.ClientSummarySegregation|undefined} value
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
*/
proto.reportpb.ListClientSummaryResponse.prototype.setSegregation = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
 */
proto.reportpb.ListClientSummaryResponse.prototype.clearSegregation = function() {
  return this.setSegregation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListClientSummaryResponse.prototype.hasSegregation = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated ClientSummaryNonTrade non_trades = 5;
 * @return {!Array<!proto.reportpb.ClientSummaryNonTrade>}
 */
proto.reportpb.ListClientSummaryResponse.prototype.getNonTradesList = function() {
  return /** @type{!Array<!proto.reportpb.ClientSummaryNonTrade>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.ClientSummaryNonTrade, 5));
};


/**
 * @param {!Array<!proto.reportpb.ClientSummaryNonTrade>} value
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
*/
proto.reportpb.ListClientSummaryResponse.prototype.setNonTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.reportpb.ClientSummaryNonTrade=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ClientSummaryNonTrade}
 */
proto.reportpb.ListClientSummaryResponse.prototype.addNonTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.reportpb.ClientSummaryNonTrade, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
 */
proto.reportpb.ListClientSummaryResponse.prototype.clearNonTradesList = function() {
  return this.setNonTradesList([]);
};


/**
 * repeated ClientSummaryTrade trades = 6;
 * @return {!Array<!proto.reportpb.ClientSummaryTrade>}
 */
proto.reportpb.ListClientSummaryResponse.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.reportpb.ClientSummaryTrade>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.ClientSummaryTrade, 6));
};


/**
 * @param {!Array<!proto.reportpb.ClientSummaryTrade>} value
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
*/
proto.reportpb.ListClientSummaryResponse.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.reportpb.ClientSummaryTrade=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ClientSummaryTrade}
 */
proto.reportpb.ListClientSummaryResponse.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.reportpb.ClientSummaryTrade, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
 */
proto.reportpb.ListClientSummaryResponse.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};


/**
 * optional ClientSummaryAccountSetup account_setup = 7;
 * @return {?proto.reportpb.ClientSummaryAccountSetup}
 */
proto.reportpb.ListClientSummaryResponse.prototype.getAccountSetup = function() {
  return /** @type{?proto.reportpb.ClientSummaryAccountSetup} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ClientSummaryAccountSetup, 7));
};


/**
 * @param {?proto.reportpb.ClientSummaryAccountSetup|undefined} value
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
*/
proto.reportpb.ListClientSummaryResponse.prototype.setAccountSetup = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListClientSummaryResponse} returns this
 */
proto.reportpb.ListClientSummaryResponse.prototype.clearAccountSetup = function() {
  return this.setAccountSetup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListClientSummaryResponse.prototype.hasAccountSetup = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.MarginRequirementDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.MarginRequirementDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.MarginRequirementDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.MarginRequirementDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
    assetType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    closingPrice: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isMarginable: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    leveragedFactor: jspb.Message.getFieldWithDefault(msg, 7, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 8, ""),
    previousQty: jspb.Message.getFieldWithDefault(msg, 9, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 10, ""),
    previousMarketValue: jspb.Message.getFieldWithDefault(msg, 11, ""),
    exchangeReq: jspb.Message.getFieldWithDefault(msg, 12, ""),
    exchangeRate: jspb.Message.getFieldWithDefault(msg, 13, ""),
    houseReq: jspb.Message.getFieldWithDefault(msg, 14, ""),
    houseRate: jspb.Message.getFieldWithDefault(msg, 15, ""),
    fedReq: jspb.Message.getFieldWithDefault(msg, 16, ""),
    fedRate: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.MarginRequirementDetail}
 */
proto.reportpb.MarginRequirementDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.MarginRequirementDetail;
  return proto.reportpb.MarginRequirementDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.MarginRequirementDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.MarginRequirementDetail}
 */
proto.reportpb.MarginRequirementDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosingPrice(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMarginable(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeveragedFactor(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousQty(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousMarketValue(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeReq(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeRate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseReq(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setHouseRate(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedReq(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setFedRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.MarginRequirementDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.MarginRequirementDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.MarginRequirementDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.MarginRequirementDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsMarginable();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLeveragedFactor();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPreviousQty();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPreviousMarketValue();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getExchangeReq();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getExchangeRate();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getHouseReq();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getHouseRate();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFedReq();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getFedRate();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cusip = 2;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol_description = 3;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string asset_type = 4;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string closing_price = 5;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getClosingPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setClosingPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_marginable = 6;
 * @return {boolean}
 */
proto.reportpb.MarginRequirementDetail.prototype.getIsMarginable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setIsMarginable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string leveraged_factor = 7;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getLeveragedFactor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setLeveragedFactor = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string qty = 8;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string previous_qty = 9;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getPreviousQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setPreviousQty = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string market_value = 10;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string previous_market_value = 11;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getPreviousMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setPreviousMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string exchange_req = 12;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getExchangeReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setExchangeReq = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string exchange_rate = 13;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getExchangeRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setExchangeRate = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string house_req = 14;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getHouseReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setHouseReq = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string house_rate = 15;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getHouseRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setHouseRate = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string fed_req = 16;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getFedReq = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setFedReq = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string fed_rate = 17;
 * @return {string}
 */
proto.reportpb.MarginRequirementDetail.prototype.getFedRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.MarginRequirementDetail} returns this
 */
proto.reportpb.MarginRequirementDetail.prototype.setFedRate = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListMarginRequirementDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListMarginRequirementDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListMarginRequirementDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListMarginRequirementDetailsRequest}
 */
proto.reportpb.ListMarginRequirementDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListMarginRequirementDetailsRequest;
  return proto.reportpb.ListMarginRequirementDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListMarginRequirementDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListMarginRequirementDetailsRequest}
 */
proto.reportpb.ListMarginRequirementDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListMarginRequirementDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListMarginRequirementDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListMarginRequirementDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional google.type.Date date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListMarginRequirementDetailsRequest} returns this
*/
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListMarginRequirementDetailsRequest} returns this
 */
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string master_account_no = 2;
 * @return {string}
 */
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListMarginRequirementDetailsRequest} returns this
 */
proto.reportpb.ListMarginRequirementDetailsRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListMarginRequirementDetailsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListMarginRequirementDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListMarginRequirementDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListMarginRequirementDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListMarginRequirementDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    marginReqDetailsList: jspb.Message.toObjectList(msg.getMarginReqDetailsList(),
    proto.reportpb.MarginRequirementDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListMarginRequirementDetailsResponse}
 */
proto.reportpb.ListMarginRequirementDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListMarginRequirementDetailsResponse;
  return proto.reportpb.ListMarginRequirementDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListMarginRequirementDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListMarginRequirementDetailsResponse}
 */
proto.reportpb.ListMarginRequirementDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.MarginRequirementDetail;
      reader.readMessage(value,proto.reportpb.MarginRequirementDetail.deserializeBinaryFromReader);
      msg.addMarginReqDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListMarginRequirementDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListMarginRequirementDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListMarginRequirementDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListMarginRequirementDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarginReqDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.MarginRequirementDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MarginRequirementDetail margin_req_details = 1;
 * @return {!Array<!proto.reportpb.MarginRequirementDetail>}
 */
proto.reportpb.ListMarginRequirementDetailsResponse.prototype.getMarginReqDetailsList = function() {
  return /** @type{!Array<!proto.reportpb.MarginRequirementDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.MarginRequirementDetail, 1));
};


/**
 * @param {!Array<!proto.reportpb.MarginRequirementDetail>} value
 * @return {!proto.reportpb.ListMarginRequirementDetailsResponse} returns this
*/
proto.reportpb.ListMarginRequirementDetailsResponse.prototype.setMarginReqDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.MarginRequirementDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.MarginRequirementDetail}
 */
proto.reportpb.ListMarginRequirementDetailsResponse.prototype.addMarginReqDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.MarginRequirementDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListMarginRequirementDetailsResponse} returns this
 */
proto.reportpb.ListMarginRequirementDetailsResponse.prototype.clearMarginReqDetailsList = function() {
  return this.setMarginReqDetailsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.SegregationDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.SegregationDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.SegregationDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.SegregationDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    priorityNo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cusip: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbolDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    assetType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    qty: jspb.Message.getFieldWithDefault(msg, 6, ""),
    closingPrice: jspb.Message.getFieldWithDefault(msg, 7, ""),
    marketValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    segQty: jspb.Message.getFieldWithDefault(msg, 9, ""),
    segAmt: jspb.Message.getFieldWithDefault(msg, 10, ""),
    excessMarginQty: jspb.Message.getFieldWithDefault(msg, 11, ""),
    excessMarginAmt: jspb.Message.getFieldWithDefault(msg, 12, ""),
    lockup: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.SegregationDetail}
 */
proto.reportpb.SegregationDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.SegregationDetail;
  return proto.reportpb.SegregationDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.SegregationDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.SegregationDetail}
 */
proto.reportpb.SegregationDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriorityNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCusip(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setQty(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosingPrice(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegQty(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegAmt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setExcessMarginQty(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setExcessMarginAmt(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.SegregationDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.SegregationDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.SegregationDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.SegregationDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriorityNo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSegQty();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSegAmt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getExcessMarginQty();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getExcessMarginAmt();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLockup();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string priority_no = 1;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getPriorityNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setPriorityNo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string cusip = 3;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol_description = 4;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string asset_type = 5;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string qty = 6;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setQty = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string closing_price = 7;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getClosingPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setClosingPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string market_value = 8;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string seg_qty = 9;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getSegQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setSegQty = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string seg_amt = 10;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getSegAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setSegAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string excess_margin_qty = 11;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getExcessMarginQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setExcessMarginQty = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string excess_margin_amt = 12;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getExcessMarginAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setExcessMarginAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string lockup = 13;
 * @return {string}
 */
proto.reportpb.SegregationDetail.prototype.getLockup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SegregationDetail} returns this
 */
proto.reportpb.SegregationDetail.prototype.setLockup = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListSegregationDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListSegregationDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListSegregationDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListSegregationDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListSegregationDetailsRequest}
 */
proto.reportpb.ListSegregationDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListSegregationDetailsRequest;
  return proto.reportpb.ListSegregationDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListSegregationDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListSegregationDetailsRequest}
 */
proto.reportpb.ListSegregationDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListSegregationDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListSegregationDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListSegregationDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListSegregationDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional google.type.Date date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListSegregationDetailsRequest.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListSegregationDetailsRequest} returns this
*/
proto.reportpb.ListSegregationDetailsRequest.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListSegregationDetailsRequest} returns this
 */
proto.reportpb.ListSegregationDetailsRequest.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListSegregationDetailsRequest.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string master_account_no = 2;
 * @return {string}
 */
proto.reportpb.ListSegregationDetailsRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListSegregationDetailsRequest} returns this
 */
proto.reportpb.ListSegregationDetailsRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListSegregationDetailsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListSegregationDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListSegregationDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListSegregationDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListSegregationDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    segregationDetailsList: jspb.Message.toObjectList(msg.getSegregationDetailsList(),
    proto.reportpb.SegregationDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListSegregationDetailsResponse}
 */
proto.reportpb.ListSegregationDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListSegregationDetailsResponse;
  return proto.reportpb.ListSegregationDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListSegregationDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListSegregationDetailsResponse}
 */
proto.reportpb.ListSegregationDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.SegregationDetail;
      reader.readMessage(value,proto.reportpb.SegregationDetail.deserializeBinaryFromReader);
      msg.addSegregationDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListSegregationDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListSegregationDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListSegregationDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListSegregationDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSegregationDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.SegregationDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SegregationDetail segregation_details = 1;
 * @return {!Array<!proto.reportpb.SegregationDetail>}
 */
proto.reportpb.ListSegregationDetailsResponse.prototype.getSegregationDetailsList = function() {
  return /** @type{!Array<!proto.reportpb.SegregationDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.SegregationDetail, 1));
};


/**
 * @param {!Array<!proto.reportpb.SegregationDetail>} value
 * @return {!proto.reportpb.ListSegregationDetailsResponse} returns this
*/
proto.reportpb.ListSegregationDetailsResponse.prototype.setSegregationDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.SegregationDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.SegregationDetail}
 */
proto.reportpb.ListSegregationDetailsResponse.prototype.addSegregationDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.SegregationDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListSegregationDetailsResponse} returns this
 */
proto.reportpb.ListSegregationDetailsResponse.prototype.clearSegregationDetailsList = function() {
  return this.setSegregationDetailsList([]);
};


goog.object.extend(exports, proto.reportpb);
